(function () {
  'use strict';

  var ultimo = null;

  // El tema emite variant:add antes que toast:show, así que aquí
  // guardamos la línea recién agregada para poder ilustrar el aviso.
  document.addEventListener('variant:add', function (e) {
    var items = e.detail && e.detail.items;
    if (items && items.length) ultimo = items[0];
  }, true);

  function escapar(txt) {
    var d = document.createElement('div');
    d.textContent = txt == null ? '' : String(txt);
    return d.innerHTML;
  }

  // Las URLs del CDN ya traen parámetros, así que el ancho se agrega
  // respetando lo que haya.
  function miniatura(url, ancho) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + ancho;
  }

  // La etiqueta corta vive en el metacampo custom.sku de la variante y
  // no viaja en la respuesta de cart/add.js: la toma del mapa impreso
  // por hv-toast-producto.liquid.
  function etiqueta(item) {
    var el = document.querySelector('[data-hv-toast-variantes]');

    if (el) {
      try {
        var mapa = JSON.parse(el.textContent);
        for (var i = 0; i < mapa.length; i++) {
          if (String(mapa[i].id) === String(item.id) && mapa[i].label) {
            return mapa[i].label;
          }
        }
      } catch (err) {}
    }

    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }

    return '';
  }

  document.addEventListener('toast:show', function (e) {
    var d = e.detail;
    if (!d || d.tone === 'error') return;
    if (d.hvCompuesto) return;
    if (!ultimo) return;

    var item = ultimo;
    var img = item.image || (item.featured_image && item.featured_image.url) || '';
    var titulo = item.product_title || item.title || '';
    var corta = etiqueta(item);

    var html = '<div class="hv-toast">';

    if (img) {
      html += '<img class="hv-toast__media" src="' + escapar(miniatura(img, 120)) +
              '" alt="" width="48" height="60" loading="lazy">';
    }

    html += '<span class="hv-toast__text">' +
            '<span class="hv-toast__title">' + escapar(titulo) + '</span>';

    if (corta) {
      html += '<span class="hv-toast__variant">' + escapar(corta) + '</span>';
    }

    html += '</span></div>';

    d.hvCompuesto = true;
    d.message = html;
  }, true);
})();